export const ACTIVATE_SIDE_CONTEXTMENU = 'ACTIVATE_SIDE_CONTEXTMENU';
export const CLOSE_SIDE_CONTEXTMENU = 'CLOSE_SIDE_CONTEXTMENU';

export interface ContextMenuData {
    x: number;
    y: number;
    options?: {
        value: string;
    };
    active: boolean;
    id: string;
}

export interface actionContextMenu {
    type: string;
    payload: ContextMenuData;
}

/**
 * Nos ayuda a activar y desactivar el menú
 * @param payload
 */
export const ActivateSideContextMenuAction = (payload: ContextMenuData): actionContextMenu => {
    return {
        type: ACTIVATE_SIDE_CONTEXTMENU,
        payload,
    };
};

export const CloseSideContextMenuAction = () => {
    return {
        type: CLOSE_SIDE_CONTEXTMENU,
    };
};
